export const initialState = {
    name: '',
    regionID: '',
    description: '',
};
export const trsPath = '/trs-clusters';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'TRS Clusters', path: trsPath },
    { label: 'Add Cluster', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'TRS Clusters', path: trsPath },
    { label: 'Edit Cluster', path: '' },
];

export const addHeader = 'Cluster Details';
export const editHeader = 'Edit Cluster Details';

export const clusterDescSuffix = 'telecommunications cluster';

export const ERROR_MESSAGES = {
    NAME_REQUIRED: 'Cluster name is required',
    REGION_REQUIRED: 'Region is required',
    CLUSTER_NAME_REQUIRED:
        'Cluster name is required and must be at least 2 characters',
    REGION_ALREADY_USED:
        'Only one cluster per region is supported. This region already has a cluster, so you cannot save a cluster for this region.',
};
